(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["santini-language-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('santini-language-dialog');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const key = 'santini_language_choice_v1';
  const remember = value => {
    try { localStorage.setItem(key, JSON.stringify({value, expires:Date.now()+180*86400000})); } catch {}
  };
  document.addEventListener('change', event => {
    if (event.target.name === 'language_code' && !dialog.contains(event.target)) remember(event.target.value);
  });
  let remembered = false;
  try {
    const choice = JSON.parse(localStorage.getItem(key));
    remembered = choice && choice.expires > Date.now();
  } catch {}
  if (remembered) return;
  const refresh = () => {
    const selected = form.querySelector('input[name="language_code"]:checked').value;
    dialog.querySelectorAll('[data-language-copy]').forEach(node => {node.hidden = node.dataset.languageCopy !== selected;});
  };
  form.addEventListener('change', refresh);
  form.addEventListener('submit', event => {
    const value = form.querySelector('input[name="language_code"]:checked').value;
    remember(value);
    if (value === dialog.dataset.locale) {event.preventDefault();dialog.close();}
  });
  const dismiss = () => {remember(dialog.dataset.locale);dialog.close();};
  dialog.querySelector('.santini-language-close').addEventListener('click', dismiss);
  dialog.addEventListener('cancel', dismiss);
  const show = async () => {
    let language = navigator.language.toLowerCase().startsWith('sv') ? 'sv' : 'en';
    try {
      const root = dialog.dataset.root.replace(/\/?$/, '/');
      const response = await fetch(root+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {signal:AbortSignal.timeout(2000)});
      if (response.ok) {
        const data = await response.json();
        const country = data.detected_values?.country?.handle;
        if (country) language = country.toUpperCase() === 'SE' ? 'sv' : 'en';
      }
    } catch {}
    form.querySelector('input[value="'+language+'"]').checked = true;
    refresh();
    if (!document.documentElement.contains(dialog)) return;
    dialog.showModal();
  };
  show();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["santini-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
const dialog=document.getElementById('santini-newsletter');
if(!dialog)return;
const storageKey='santini_newsletter_until_v1';
const pendingKey='santini_newsletter_pending_v1';
const get=(storage,key)=>{try{return storage.getItem(key);}catch{return null;}};
const set=(storage,key,value)=>{try{storage.setItem(key,String(value));}catch{}};
const pending=get(sessionStorage,pendingKey)==='1';
const success=!!dialog.querySelector('[data-signup-success]')&&pending;
const errors=!!dialog.querySelector('[data-signup-error]')&&pending;
const hide=()=>{set(localStorage,storageKey,Math.max(Number(get(localStorage,storageKey))||0,Date.now()+7*86400000));dialog.close();};
dialog.querySelector('.sn-close').addEventListener('click',hide);
dialog.querySelector('.sn-dismiss').addEventListener('click',hide);
dialog.addEventListener('cancel',hide);
dialog.querySelector('form').addEventListener('submit',()=>set(sessionStorage,pendingKey,'1'));
if(success){set(localStorage,storageKey,Date.now()+365*86400000);set(sessionStorage,pendingKey,'0');}
if(!success&&!errors&&Number(get(localStorage,storageKey))>Date.now())return;
let started=Number(get(sessionStorage,'santini_newsletter_start_v1'));
if(!started){started=Date.now();set(sessionStorage,'santini_newsletter_start_v1',started);}
const show=()=>{
if(document.hidden||document.querySelector('dialog[open]')){setTimeout(show,500);return;}
dialog.showModal();
};
setTimeout(show,success||errors?0:Math.max(0,10000-(Date.now()-started)));
})();
  } catch(e) { console.error(e); }
})();

})();
